import { exchangeToken } from '@lms/api-client/backend';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// The magic-link email points the browser at `${APP_URL}/api/login/token?token=`
// (the backend builds this path). This route replaces the old Next.js route
// handler: it exchanges the token for a session cookie (set by the backend on
// this same origin) and then lands the user in their site's admin area.
function slugFromToken(token: string): string | undefined {
  try {
    const payload = token.split('.')[1];
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return (JSON.parse(json) as { slug?: string }).slug;
  } catch {
    return undefined;
  }
}

export function TokenLanding() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode's double-invoke
    ran.current = true;

    const token = params.get('token');
    if (!token) {
      navigate('/', { replace: true });
      return;
    }
    const slug = slugFromToken(token);

    exchangeToken(token)
      .then(() => navigate(slug ? `/${slug}/admin` : '/', { replace: true }))
      .catch(() =>
        navigate(
          `/${slug ?? 'safe'}/login/error?message=${encodeURIComponent(
            'This login link is invalid or has expired.',
          )}`,
          { replace: true },
        ),
      );
  }, [params, navigate]);

  return (
    <div className="flex h-dvh items-center justify-center text-muted-foreground">
      Signing you in…
    </div>
  );
}
